import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody } from 'reactstrap';
import { baseURL, CHANNEL, CHANNELTWO, CONFIG, formatCurrency } from '../../configs/exports.js';
import * as moment from 'moment';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import { FormControl } from 'react-bootstrap'
import { HOURS_FROM, HOURS_TO } from "../../configs/exports.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import DatePicker from 'react-datepicker'; // Import react-datepicker
import "react-datepicker/dist/react-datepicker.css"; // Import styles
import { enZA } from 'date-fns/locale'; // Import African locale



export class PreStats extends React.Component {
    constructor(props) {
        super(props);
        this.applyCallback = this.applyCallback.bind(this);



        this.columns = [

            {
                key: 'year',
                TrOnlyClassName: 'tsc',
                text: 'Year',
                className: 'tsc',
                align: 'left'
            },


            {
                key: 'month',
                TrOnlyClassName: 'tsc',
                text: 'Month',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'ussd',
                TrOnlyClassName: 'tsc',
                text: 'Ussd',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'total_tickets',
                TrOnlyClassName: 'tsc',
                text: 'Total Ticket',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'total_amount',
                TrOnlyClassName: 'tsc',
                text: 'Total Amount',
                className: 'tsc',
                align: 'left'
            },

            {
                key: 'total_win_amount',
                TrOnlyClassName: 'tsc',
                text: 'Total Win Amount',
                className: 'tsc',
                align: 'left'
            }
        ]

        this.config = {
            key_column: "tsc",
            length_menu: [500, 1000, 1500],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 2000,
            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                no_data_text: "No data was found",
                filter: "Enter Phone Number",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                }
            },
            button: {
                excel: true,
                print: false,
                csv: true
            }
        }


        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            bet: 0,
            won: 0,
            data: [],
        };
        let now = new Date();
        const today = moment().format('YYYY-MM-DD'); // safer with moment

        let start = moment().startOf('month').format('YYYY-MM-DD');
        let end = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');

        this.state = {
            start: start,
            end: end,
            total: 0,
            count: 0,
            startDate: start,
            startTime: '00:00',
            endDate: today,
            endTime: '23:59',
            isPageLoad: true,
        };

    }


    componentDidMount() {
        let start = moment().startOf('month').format('YYYY-MM-DD');

        this.setState({
            startDate: start,
            endDate: moment(new Date()).format('DD MMM, YYYY'),
            isPageLoad: true,
            valuedate: "Today"
        })

        // alert(JSON.stringify(this.props.record_id.id))

        localStorage.setItem("STARTDATE", moment(new Date()).format('YYYY-MM-DD') + ` ${HOURS_FROM}:00:00`)
        localStorage.setItem("ENDDATE", moment(new Date()).format('YYYY-MM-DD') + ` ${HOURS_TO}:59:59`)


        const startDate = start;
        const endDate = moment(new Date()).format('YYYY-MM-DD') + ` ${HOURS_TO}:59:59`;

        // Call the `getData` function
        this.getData("", startDate, endDate);
    }



    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };



    handleChangeDate = (date) => {
        this.setState({
            startDate: moment(date).format('YYYY-MM-DD')
        });
    };

    handleChangeTmeDate = (date) => {
        this.setState({
            endDate: moment(date).format('YYYY-MM-DD')
        });
    };

    handleSearch = (e) => {
        e.preventDefault();


        const { startDate, startTime, endDate, endTime } = this.state;

        // Combine date and time into ISO format (YYYY-MM-DDTHH:mm:ss)
        const start = `${startDate} ${startTime}`;
        const end = `${endDate} ${endTime}`;


        // Format the date-time strings using Moment.js
        const formattedStart = moment(start).format('YYYY-MM-DD HH:mm:ss');
        const formattedEnd = moment(end).format('YYYY-MM-DD HH:mm:ss');

        localStorage.setItem("STARTDATE", formattedStart)
        localStorage.setItem("ENDDATE", formattedEnd)
        // Call the getData function with formatted start and end
        this.getData("", formattedStart, formattedEnd);
    }
    getData = (queryString = '', startDate, endDate, channel) => {
        let url =
            baseURL +
            `/ticket_stats_logs?channel=${CHANNELTWO}&ussd=${CHANNEL}&startDate="${startDate}"&endDate="${endDate}"&${queryString}`
        this.setState({
            isLoading: true
        })

        // alert(url)
        axios.all([axios.get(url, CONFIG)]).then(
            axios.spread(branchResponse => {
                this.setState(
                    {
                        admins: branchResponse.data.mdata,
                        isLoading: false
                    },
                    function () {
                        var data = []
                        let mtotal = 0

                        let mcount = 0

                        this.setState({
                            data: branchResponse.data.data,
                            // total: branchResponse.data.mtotal[0].deposits,
                            count: mcount,
                            // won_amount: branchResponse.data.mtotal[0].amount
                        })
                    }
                )
            })
        )
    }



    applyCallback(startDate, endDate) {

        localStorage.setItem("STARTDATE", startDate)
        localStorage.setItem("ENDDATE", endDate)
        let Sdate1 = moment(startDate).format('DD MMM, YYYY');
        let Edate2 = moment(endDate).format('DD MMM, YYYY');
        this.setState({
            valuedate: Sdate1 + " " + Edate2,
            startDate: Sdate1,
            isPageLoad: true,
            endDate: Edate2
        })


        this.getData("", moment(new Date(startDate)).format('YYYY-MM-DD HH:mm:ss'), moment(new Date(endDate)).format('YYYY-MM-DD HH:mm:ss'))
    }



    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(queryString, moment(localStorage.getItem("STARTDATE")).format('YYYY-MM-DD HH:mm:ss'), moment(localStorage.getItem("ENDDATE")).format('YYYY-MM-DD HH:mm:ss'))


    }




    getDataUpdate() {
        // let queryString = ("filter_value=&page_number=0&page_size=10&sort_order=false")

        this.getData("", moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
    }

    render() {
        let ranges = {
            "Today Only": [moment(this.state.start), moment(this.state.end)],
            "Yesterday Only": [
                moment(this.state.start).subtract(1, "days"),
                moment(this.state.end).subtract(1, "days")
            ],
            "3 Days": [moment(this.state.start).subtract(3, "days"), moment(this.state.end)],
            "5 Days": [moment(this.state.start).subtract(5, "days"), moment(this.state.end)],
            "1 Week": [moment(this.state.start).subtract(7, "days"), moment(this.state.end)],
            "2 Weeks": [moment(this.state.start).subtract(14, "days"), moment(this.state.end)],
            "1 Month": [moment(this.state.start).subtract(1, "months"), moment(this.state.end)],
            "1 Year": [moment(this.state.start).subtract(1, "years"), moment(this.state.end)]
        };
        let local = {
            "format": "DD-MM-YYYY",
            "sundayFirst": false
        }


        const { startDate, startTime, endDate, endTime } = this.state;


        return (
            <div style={{ marginTop: '-20px' }} >
                < >
                    < Card >
                        <CardBody >
                            < >

                                <div className="row">
                                    <div className="col-md-8">
                                        <h3><b>Stats</b></h3>
                                    </div>
                                </div>
                                <br />
                                <form onSubmit={this.handleSearch}>
                                    <div className="row align-items-end mb-4">
                                        {/* Start Date Picker */}
                                        <div className="col-md-2 col-sm-3">
                                            <label className="form-label">Start Date</label>
                                            <DatePicker
                                                selected={startDate ? new Date(startDate) : null}
                                                onChange={(date) => this.handleChangeDate(date, 'startDate')}
                                                dateFormat="yyyy-MM-dd" // Set format to YYYY-MM-DD
                                                locale={enZA} // Set the African locale for the picker
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="col-md-2 col-sm-3">
                                            <label className="form-label">End Date</label>
                                            <DatePicker
                                                selected={endDate ? new Date(endDate) : null}
                                                onChange={(date) => this.handleChangeTmeDate(date, 'endDate')}
                                                dateFormat="yyyy-MM-dd" // Set format to YYYY-MM-DD
                                                locale={enZA} // Set the African locale for the picker
                                                className="form-control"
                                            />
                                        </div>


                                        {/* End Time Picker
                                        <div className="col-md-2 col-sm-3">
                                            <label className="form-label">End Time</label>
                                            <input
                                                type="time"
                                                className="form-control"
                                                name="endTime"
                                                value={endTime}
                                                onChange={(e) => this.setState({ endTime: e.target.value })}
                                            />
                                        </div>
 */}
                                        {/* Search Button */}
                                        <div className="col-md-2 col-sm-3">
                                            <button type="submit" className="btn btn-primary w-100">
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </form>
                                <br />
                                <br />
                                {/* Summary */}
                                <div className="row mb-3">

                                    <div className="col-md-4">
                                        {/* <h5>Total Win: <b>{this.state.won_amount}</b></h5> */}
                                    </div>
                                </div>
                                <br />
                                {/* <h3>Total Counts  <b>{this.state.count}</b></h3>

                                <h3>Total Stake  <b>{this.state.total}</b></h3> */}
                                <br />
                                <div className="panel-body" >
                                    <ReactDatatable
                                        config={this.config}
                                        records={this.state.data}
                                        columns={this.columns}
                                        id="tsc"
                                        loading={this.state.isLoading}
                                        total_record={this.state.mdata}
                                        onChange={this.tableChangeHandler} />
                                </div>
                            </>

                        </CardBody>

                    </Card>
                </>
            </div>

        )
    }
}